import { authStore } from "./authStore";
import { webAPI } from "../api/Api";
import { makeAutoObservable, runInAction, toJS } from "mobx";
import { SearchRequest, FilterItem, Search } from "../api/Types";
import ApiLists from "../modules/api/Lists";
import ApiNsi from "../modules/api/Nsi";
import apiAdmin from "../modules/Admin/api";
import {
  PerPageSettings,
  WithBooleanFlag,
  Sorter,
  Filter,
  ExpandableKeys,
} from "./core";
import { SortingDirection } from "../constants/Enums";
import { getFilesWithThumbUrls } from "../api/helpers";

export interface IOrg {
  id: number;
  organizationId: number;
  name: string;
  shortName: string;
  regionCodeLegal: string;
  regionNameLegalstring;
  addressLegal: string;
  addressLegalGuid: string;
  regionCodeFact: string;
  regionNameFact: string;
  addressFact: string;
  addressFactGuid: string;
  officeFact: string;
  isFilial: true;
  headFio: string;
  headPhone: string;
  inn: string;
  kpp: string;
  ogrn: string;
  okved: string;
  ogoku: string;
  oktmo: string;
  okfs: string;
  registrationDt: Date;
  endDt: Date;
  isRegionalCenter: true;
  isRegulActivity: true;
  phone: string;
  site: string;
  email: string;
  opfId: number;
  iogvId: number;
  orgTypeId: number;
  budgetOrgId: number;
  energySavingResponsibleFio: string;
  energySavingResponsiblePosition: string;
}

export class Organizations {
  /*********************************/
  // Список организаций
  orgs = [];

  paginator = new PerPageSettings();
  isLoading = new WithBooleanFlag();
  isLoadingOrg = new WithBooleanFlag();
  filter = new Filter();

  sorter = new Sorter();
  search: Search = {
    text: "",
    fieldNames: ["name"],
    allTextFields: true,
  };

  organizationsParamsRowKeys = new ExpandableKeys();

  regionCode = null;
  firstNumberOrg = 1;

  orgsId = null;
  optId = null;
  orgsName = "";
  buildingOrgsId = null;
  id = null;
  buildingId = null;
  organizationName = "";
  organization: IOrg;

  organizationId = null;

  //devices
  devices = [];
  pagesTotal = 0;
  firstNumDevice = 0;
  stateDevices = "pending";
  totalCountDevices = 0;

  viewAllOrgs = false;
  grbsArray = [];
  organizations = [];

  currentOrganization = null;

  constructor() {
    makeAutoObservable(this, {}, { deep: true, autoBind: true });
    // this.sorter.setSortData("id", SortingDirection.Asc);
  }

  getOrganizationById(id) {
    ApiLists.getOrganizationById(id).then((res) => {
      this.organization = res.data;
    });
  }

  getIdsOfOrganization = (organizationId) => {
    runInAction(() => {
      localStorage.setItem("organizationId", organizationId);
      // this.organizationId = +localStorage.getItem("organizationId");
    });
  };

  getOrganizationName(name) {
    this.organizationName = name;
  }
  getCurrentOrganizationId = async () => {
    if (authStore?.userProfile?.organizationId) {
      const request: SearchRequest = {
        page: this.paginator.page,
        count: this.paginator.perPage,
        sortItems: this.sorter.sortData,
        filterItems: this.filter.filterItems,
        search: {
          text: authStore?.userProfile?.organizationName?.toString() ?? "",
          fieldNames: ["name"],
          allTextFields: false,
        },
      };

      try {
        const res = await webAPI.post(
          "/efficiency/OrganizationProfile",
          request,
        );
        const currrentOrg = res.data.items.filter(
          (elem) =>
            elem.organizationId === authStore.userProfile.organizationId,
        )[0];
        runInAction(() => {
          this.currentOrganization = currrentOrg;
        });
      } catch (e) {}
    }
  };

  getOrgs = async (history) => {
    this.isLoading.setTrue();
    try {
      this.getCurrentOrganizationId();

      const request: SearchRequest = {
        page: this.paginator.page,
        count: this.paginator.perPage,
        sortItems: this.sorter.sortData,
        filterItems: this.filter.filterItems,
        search: this.search,
      };
      const res = await webAPI.post("/efficiency/OrganizationProfile", request);

      runInAction(() => {
        const items = res.data.items.map(({ children, ...other }) => {
          return {
            items: children,
            ...other,
          };
        });
        if (this.currentOrganization && !this.search.text) {
          const index = items.findIndex(
            (item) =>
              item.organizationId === authStore.userProfile.organizationId,
          );
          if (index !== -1) {
            //такая орагнизация есть в списке
            items.splice(index, 1);
            items.unshift(this.currentOrganization);
          } else {
            //добавляем организацию в начало и урезаем последний элемент
            items.unshift(this.currentOrganization);
            items.pop();
          }
        }
        this.orgs = items;
        this.paginator.updateMeta(res.data);
        this.firstNumberOrg = res.data.firstItemNumber;

        if (
          res.data.itemsTotal === 1 &&
          !this.search.text &&
          !this.filter.filterItems?.length
        ) {
          localStorage.setItem("organizationId", this.orgs[0]?.organizationId);
          history.push(`/efficiency/organization-profile/${this.orgs[0]?.id}`);
        }
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.isLoading.setFalse();
    }
  };

  getBudgetOrgs = async () => {
    try {
      const { data } = await ApiNsi.getBudgetOrgs();

      runInAction(() => {
        this.grbsArray = data.items;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
  getDevicesByOrganization = async (id, page, count, filterItems) => {
    this.stateDevices = "pending";
    try {
      const { data } = await ApiLists.getDevicesByOrg(
        id,
        page,
        count,
        filterItems,
      );

      for (const device of data.items) {
        device.meteringDeviceDocumentFiles = await getFilesWithThumbUrls(
          device.meteringDeviceDocumentFiles.map((f) => f.file),
        );
      }
      for (const device of data.items) {
        device.meteringDevicePaymentFiles = await getFilesWithThumbUrls(
          device.meteringDevicePaymentFiles.map((f) => f.file),
        );
      }

      // data.items.forEach(async (device) => {
      //   if (device.meteringDeviceDocumentFiles?.length) {
      //     device.meteringDeviceDocumentFiles = await getFilesWithThumbUrls(
      //       device.meteringDeviceDocumentFiles.map((f) => f.file),
      //     );
      //   }
      //   if (device.meteringDevicePaymentFiles?.length) {
      //     device.meteringDevicePaymentFiles = await getFilesWithThumbUrls(
      //       device.meteringDevicePaymentFiles.map((f) => f.file),
      //     );
      //   }
      // });

      runInAction(() => {
        this.devices = data.items;
        this.pagesTotal = data.pagesTotal;
        this.firstNumDevice = data.firstItemNumber;
        this.stateDevices = "done";
        this.totalCountDevices = data.itemsTotal;
      });
    } catch (error) {
      runInAction(() => {
        this.stateDevices = "error";
        console.log(error);
      });
    }
  };

  getOrganizations = async (isFilter = "") => {
    try {
      this.isLoadingOrg.setTrue();
      const { data } = await apiAdmin.getAllOrganizations(0, 0, "");

      runInAction(() => {
        if (isFilter) {
          this.organizations = data.items?.filter((item) => item?.[isFilter]);
        } else {
          this.organizations = data.items;
        }
      });
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoadingOrg.setFalse();
    }
  };

  addNewDevice(device) {
    this.devices.push(device);
  }
  updateDevice(device) {
    this.devices = this.devices.map((dev) =>
      dev.id === device.id ? device : dev,
    );
  }
}

export default new Organizations();
